import { Theme } from 'config';

const styles = (theme: Theme) => ({
  searchGrid: {
    margin: '0 auto !important',
    width: '100% !important',
  },
  cardContainer: {
    borderRadius: '.42857em !important',
    boxShadow: 'none !important',
  },
  cardContent: {
    display: 'flex',
    padding: '.5625rem !important',
  },
  searchGroup: {
    display: 'flex !important',
    alignItems: 'center !important',
    backgroundColor: '#fafafa !important',
    borderRadius: '.25rem !important',
    border: 'none !important',
    margin: '0 !important',
    width: '100%',
  },
  searchText: {
    display: 'flex !important',
    margin: '.25rem 0 !important',
    padding: '0 !important',
    width: '100%',
    fontSize: '.875rem !important',
    '@global .ui.input': {
      width: '100% !important',
      '&::placeholder': {
        color: '#646464 !important',
        opacity: 1,
      },
      '& input': {
        border: 'none !important',
        backgroundColor: '#fafafa !important',
        paddingTop: '.5rem !important',
        paddingBottom: '.5rem !important',
      },
    },
  },
  searchState: {
    margin: '0 !important',
    '& div': {
      '&.ui.selection.dropdown': {
        padding: '.5rem 1rem !important',
        fontSize: '1rem !important',
        minWidth: '12rem !important',
        lineHeight: '1.2em',
        '& .default.text': {
          color: 'rgba(0, 0, 0, .25) !important',
        },
      },
    },
  },
  button: {
    backgroundColor: '#683caf !important',
    borderRadius: '1.5rem !important',
    color: '#fff !important',
    fontSize: '.875rem',
    margin: '.25rem 0 .25rem 1rem !important',
    opacity: 1,
    padding: '.5625rem 1.5em .5625rem !important',
    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  '@global .ui.disabled.button ': {
    backgroundColor: '#d8dee1 !important',
    opacity: '1 !important',
  },
});

export default styles;
